import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

export interface ListPageEmptyProps {
  /** Main message (e.g. "No companies match your filters") */
  message: string;
  /** Secondary text (e.g. "Try clearing filters to see more results") */
  secondary?: string;
  /** When true, show a "Clear filters" button that calls onClearFilters */
  hasActiveFilters?: boolean;
  onClearFilters?: () => void;
  /** Optional icon element (e.g. BusinessIcon, PeopleIcon) */
  icon?: React.ReactNode;
  /** Optional primary action (e.g. "Create first item") - render custom button if needed */
  primaryAction?: React.ReactNode;
}

const ListPageEmpty: React.FC<ListPageEmptyProps> = ({
  message,
  secondary,
  hasActiveFilters,
  onClearFilters,
  icon,
  primaryAction,
}) => (
  <Box
    sx={{
      height: '100%',
      minHeight: 280,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      p: 4,
    }}
  >
    {icon && (
      <Box sx={{ color: 'text.secondary', mb: 2, '& .MuiSvgIcon-root': { fontSize: 48 } }}>
        {icon}
      </Box>
    )}
    <Typography variant="h6" color="text.secondary" gutterBottom textAlign="center">
      {message}
    </Typography>
    {secondary && (
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }} textAlign="center">
        {secondary}
      </Typography>
    )}
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', justifyContent: 'center' }}>
      {hasActiveFilters && onClearFilters && (
        <Button variant="outlined" size="small" startIcon={<ClearIcon />} onClick={onClearFilters}>
          Clear filters
        </Button>
      )}
      {primaryAction}
    </Box>
  </Box>
);

export default ListPageEmpty;
